var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:("months-grid months-grid--" + _vm.size),on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.monthNames),function(monthName,index){return _c('div',{key:index,class:_vm.clsx('month-item', {
        'current-month': index === _vm.getMonthMoment(_vm.currentDate) && _vm.selectedYear === _vm.getYearMoment(_vm.currentDate),
        'today-month': _vm.isCurrentMonthToday(index),
        'selected': _vm.isSelectedMonth(index),
        'in-range': _vm.isInMonthRange(index),
        'range-start': _vm.isMonthRangeStart(index),
        'range-end': _vm.isMonthRangeEnd(index),
        'is-disabled': _vm.isDisabledMonth(index)
      }),attrs:{"aria-label":("Select " + monthName)},on:{"click":function($event){return _vm.selectMonth(index)}}},[_vm._v(" "+_vm._s(monthName)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }